import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import PdfDownloadButton from 'components/molecules/buttons/pdfDownload/pdfDownloadButton';
import Popup from 'components/molecules/popup';
import { Form } from 'components/organisms';
import { advanceLableInitialValue } from 'components/organisms/forms/advance/advanceLabelForm';
import { FormikHelpers } from 'formik';
import { useHasPermission } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiHandCoinsLight } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteAdvanceDetail,
  useGetAdvanceDetail,
  usePutRepayment,
} from 'services/advance/index';
import { IAdvance, IRepaymentPopupForm } from 'services/advance/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const Advance = () => {
  const location = useLocation();
  const labelId = useCustomParamId('id', '/label');
  const advanceId = useCustomParamId('advanceId', '/label');

  const { t } = useTranslation();

  const hasPermission = useHasPermission();

  const advance = useGetAdvanceDetail(advanceId);

  const removeAdvanceElem = useDeleteAdvanceDetail();
  const navigate = useNavigate();
  const repaymentUpdate = usePutRepayment();

  const transformedData: IAdvance = advance.data
    ? middleware.advance.queryToForm(advance.data)
    : advanceLableInitialValue;

  const goToListPath = location.state === true ? 'unpaid-advance' : `label/${labelId}/advance`;

  const onRemoveAdvance = async (actions: PopupActions) => {
    await removeAdvanceElem.mutateAsync(advanceId, {
      onSuccess: () => {
        actions.close();
        navigate('/' + goToListPath);
      },
    });
  };

  const onRepaymentAdvance = async (
    values: IRepaymentPopupForm,
    formikHelpers: FormikHelpers<IRepaymentPopupForm>,
    actions: PopupActions | null
  ) => {
    await repaymentUpdate.mutateAsync(
      { advanceId: advanceId, ...values, version: advance.data?.version ?? 0 },
      {
        onSuccess: async () => {
          await advance.refetch();
          formikHelpers.resetForm();
          actions?.close();
        },
        onError: (error: any) => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.AdvanceLabelForm
      isPending={advance.isLoading}
      i18nextPrefix='advance'
      initialValues={transformedData}
      status={{ displayMode: true }}
      onSubmit={() => {}}
      title={transformedData?.description}
      backPath={goToListPath ? goToListPath : ''}
      displayMode
      disable
      customBackItem
      topbarContent={
        <div className='flex gap-2'>
          <PdfDownloadButton
            isClear
            pdf1Url={transformedData?.finalAdvanceDocumentPath}
            pdf2Url={transformedData?.proposalAdvanceDocumentPath}
          />
          {!!advance.data?.remainingNetAmount && (
            <Popup.Repayment
              onSubmit={onRepaymentAdvance}
              maxRepaymentValue={advance.data?.remainingNetAmount}
              name={advance.data?.description}
              trigger={
                <Button
                  type='button'
                  isClear
                  variant={BUTTON_VARIANT.warning}
                  onlyIcon>
                  <Button.Icon icon={<PiHandCoinsLight />} />
                </Button>
              }
            />
          )}

          {hasPermission('AdvancePermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning onRemove={onRemoveAdvance} />
          )}
        </div>
      }
      disableTabs={[transformedData?.repaymentsFromAllContracts ? 1 : null]}
    />
  );
};

export default Advance;
